const CHECK_ITEMS = ["Tires", "Brakes", "Fluids", "Battery", "Belts", "Hoses", "Suspension", "Lights"];
const OPTIONS = ["OK", "Attention", "N/A"];

const optColor = { OK: "bg-green-600 text-white", Attention: "bg-amber-500 text-black", "N/A": "bg-zinc-700 text-zinc-300" };

export const InspectionChecklist = ({ value, onChange }) => {
  const insp = value || {};
  const set = (item, opt) => onChange({ ...insp, [item]: opt });
  return (
    <div className="space-y-2" data-testid="inspection-checklist">
      {CHECK_ITEMS.map((item) => (
        <div key={item} className="flex items-center justify-between gap-2">
          <span className="text-zinc-300 text-sm">{item}</span>
          <div className="flex gap-1">
            {OPTIONS.map((opt) => (
              <button
                key={opt}
                type="button"
                data-testid={`inspection-${item.toLowerCase()}-${opt.toLowerCase().replace("/", "")}`}
                onClick={() => set(item, opt)}
                className={`px-2.5 py-1 rounded-sm text-xs font-semibold ${insp[item] === opt ? optColor[opt] : "border border-zinc-700 text-zinc-500"}`}
              >
                {opt}
              </button>
            ))}
          </div>
        </div>
      ))}
      <textarea
        data-testid="inspection-observations"
        className="w-full bg-[#0a0a0a] border border-zinc-800 text-white rounded-sm p-2.5 text-sm h-16"
        placeholder="Other observations..."
        value={insp.observations || ""}
        onChange={(e) => onChange({ ...insp, observations: e.target.value })}
      />
    </div>
  );
};
